export enum MenuActionTypes {
  InitGuestMenuList = '[MENU] Init guest menu list',
  SetMenuList = '[MENU] Set menu list'
}
